angular.module('rjmNg.directives').directive "sqlAction", [
  () ->
    restrict: "E"
    templateUrl: "directive.sqlAction.html"
    replace: false
    controllerAs: "view"
    bindToController: true
    scope:
      status: "="
    controller: [
      "$rootScope"
      (
        $rootScope
      ) ->

        view = @

        view.run = () ->
          $rootScope.$broadcast 'runSqlQuery'

        view
    ]
]
